<template>
  <a-tabs :defaultActiveKey="defaultKey">
    <a-tab-pane v-if="canViewVacationReq" tab="CONSULTA SOLICITUDES DE VACACIONES" key="1">
      <g-master ref="wfMasterComponent"
                name="wfrequestmaster"
                :endpoint="wfMaster.endpoint"
                :tableSetup="wfMaster.tableSetup"
                :actions="false"
                :modalFieldsSetup="wfMaster.modalFieldsSetup"
                @fieldsChange="fieldsChange"
                @action="masterAction">

        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-if="activarResolucion">
              <a-form-item label="Resolución" v-bind="wfMaster.fiOptions">
                <a-input
                  v-decorator="['id_resolution']"/>
              </a-form-item>
            </a-col>
            <a-col v-if="activarResolucion">
              <a-form-item label="Fecha Resolución" v-bind="wfMaster.fiOptions">
                <a-date-picker style="width: 100%"
                               v-decorator="['resolution_date']"/>
              </a-form-item>
            </a-col>
            <a-col>
              <g-dropdown label="Periodo"
                          :formItemConfig="wfMaster.fiOptions"
                          endpoint="hierarchy_lookup"
                          :decorator="['payment_period']"
                          :params="wfMaster.period_request">
              </g-dropdown>
            </a-col>
            <a-col>
              <a-form-item label="Fecha Pago" v-bind="wfMaster.fiOptions">
                <a-date-picker style="width: 100%"
                               v-decorator="['attribute9']"/>
              </a-form-item>
            </a-col>
            <template v-if="canChangeFechaInicio">
              <a-col>
                <a-form-item label="Días Solicitados" v-bind="wfMaster.fiOptions">
                  <a-input
                    v-decorator="['requested_ammount', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col>
                <a-form-item label="Fecha Inicio" v-bind="wfMaster.fiOptions">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['start_date', {  rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col>
                <a-form-item label="Fecha De Regreso" v-bind="wfMaster.fiOptions">
                  <a-input v-model="wfMaster.fecha_regreso.value"
                           disabled>
                    <a-tooltip slot="suffix" title="Calculado automáticamente">
                      <a-icon v-if="wfMaster.fecha_regreso.loading" type="loading"/>
                      <a-icon v-else type="info-circle" style="color: rgba(0,0,0,.45)"/>
                    </a-tooltip>
                  </a-input>
                </a-form-item>
              </a-col>
            </template>

          </a-row>
        </template>
        <span slot="estadoRenderer" slot-scope="{text}">
                    <a-tag
                      :color="text==='RECHAZADA' ? 'red' : (text === 'APROBADA' ? 'green' : 'blue')">{{ text }}</a-tag>
                </span>
      </g-master>

      <a-modal title="Solicitud"
               :visible="wfConfirmModal.visible"
               @ok="confirmAprobar"
               :confirmLoading="wfConfirmModal.loading"
               @cancel="cancelAprobar"
               style="top: 20px;">
        <span>¿Está seguro que desea {{ wfConfirmModal.aprobar_rechazar }} la solicitud?</span>
        <br/>
        <span>&nbsp;</span>
        <br/>
        <span>
          Comentario de {{ wfConfirmModal.aprobar ? 'aprobación' : 'rechazo' }}
        </span>
        <a-textarea autosize v-model="wfConfirmModal.comentario"></a-textarea>
        <br/>
        <a-alert type="error" :message="wfConfirmModal.mensajeError" v-if="wfConfirmModal.error"/>
      </a-modal>

    </a-tab-pane>
    <a-tab-pane tab="CONSULTA OTRAS SOLICITUDES" key="2">
      <g-master name="otrassolicitudes"
                :endpoint="reqMaster.endpoint"
                :tableSetup="reqMaster.tableSetup"
                :actions="false"
                ref="masterOtrasSolicitudes"
                @action="masterActionOtraSolicitud"
                modalWidth="90%"
                :modalFieldsSetup="reqMaster.modalFieldsSetup"
                @params="paramsTable"
      >
        <template slot="customButton">
          <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="wfMaster.colOptions" v-if="activarResolucion">
              <a-form-item label="Resolución" v-bind="wfMaster.fiOptions">
                <a-input
                  v-decorator="['id_resolution', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions" v-if="activarResolucion">
              <a-form-item label="F. Resolución" v-bind="wfMaster.fiOptions">
                <a-date-picker style="width: 100%"
                               v-decorator="['resolution_date', {  rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          label="T. Solicitud"
                          :formItemConfig="wfMaster.fiOptions"
                          :decorator="['type_req', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="reqMaster.solicitud"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          label="T. permiso"
                          :formItemConfig="wfMaster.fiOptions"
                          :decorator="['type_permission', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="reqMaster.permiso"
                          :selectedObj.sync="tipo_permiso_seleccionado"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          label="Sub Tipo"
                          :formItemConfig="wfMaster.fiOptions"
                          :decorator="['sub_type_request', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="reqMaster.sub_tipo">

              </g-dropdown>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item v-bind="wfMaster.fiOptions" :label="$t('Días')">
                <a-input-number
                  style="width: 100%"
                  v-decorator="['days', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item :label="$t('F. Permiso')" v-bind="wfMaster.fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['date_permission', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item label="Hora Inicio" v-bind="wfMaster.fiOptions">
                <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                               v-decorator="['time_return', {type:'object', rules: [{ required: activarHoras, message: 'Valor requerido' }] }]"
                               placeholder="H. Inicio"
                               style="width: 100%"
                               :disabled="!activarHoras"
                ></a-time-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item label="Hora Fin" v-bind="wfMaster.fiOptions">
                <a-time-picker :minuteStep="15" use12Hours format="hh:mm"
                               v-decorator="['time_leave', {type:'object', rules: [{ required: activarHoras, message: 'Valor requerido' }] }]"
                               placeholder="H. Fin"
                               style="width: 100%"
                               :disabled="!activarHoras"
                ></a-time-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item label="Atributo 1" v-bind="wfMaster.fiOptions">
                <a-input
                  v-decorator="['att_1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item label="Atributo 2" v-bind="wfMaster.fiOptions">
                <a-input
                  v-decorator="['att_2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item label="Atributo 3" v-bind="wfMaster.fiOptions">
                <a-input-number
                  v-decorator="['att_3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item label="Atributo 4" v-bind="wfMaster.fiOptions">
                <a-input-number
                  v-decorator="['att_4', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item :label="$t('Atributo 5')" v-bind="wfMaster.fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['att_5', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="wfMaster.colOptions">
              <a-form-item :label="$t('Atributo 6')" v-bind="wfMaster.fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['att_6', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
        <span slot="estadoRenderer" slot-scope="{text}">
                    <a-tag
                      :color="['RECHAZADA', 'CERRADA'].includes(text) ? 'red' : (text === 'APROBADA' ? 'green' : 'blue')">{{
                        text
                      }}</a-tag>
                </span>
      </g-master>
      <a-modal title="Solicitud"
               :visible="wfConfirmModalOtraSolicitud.visible"
               @ok="confirmAprobarOtraSolicitud"
               :confirmLoading="wfConfirmModalOtraSolicitud.loading"
               @cancel="cancelAprobarOtraSolicitud"
               style="top: 20px;">
        <span>¿Está seguro que desea aprobar esta solicitud la solicitud?</span>
        <br/>
        <span>&nbsp;</span>
        <br/>
        <div v-if="wfConfirmModalOtraSolicitud.visibleObs">
          <span>Comentario de aprobación</span>
          <a-textarea autosize v-model="wfConfirmModalOtraSolicitud.comentario"></a-textarea>
        </div>
        <br/>
        <a-alert type="error" :message="wfConfirmModalOtraSolicitud.mensajeError"
                 v-if="wfConfirmModalOtraSolicitud.error"/>
      </a-modal>

      <a-modal title="Solicitud"
               :visible="wfCancelModalOtraSolicitud.visible"
               @ok="confirmRechazarSolicitud"
               :confirmLoading="wfCancelModalOtraSolicitud.loading"
               @cancel="cancelRechazarSolicitud"
               style="top: 20px;">
        <span>¿Está seguro que desea rechazar esta solicitud la solicitud?</span>
        <br/>
        <span>&nbsp;</span>
        <br/>
        <span>
                    Comentario de rechazo</span>
        <a-textarea autosize v-model="wfCancelModalOtraSolicitud.comentario"></a-textarea>
        <br/>
        <a-alert type="error" :message="wfCancelModalOtraSolicitud.mensajeError"
                 v-if="wfCancelModalOtraSolicitud.error"/>
      </a-modal>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
import JsUtils from '@/util/JsUtils'
import DateUtils from '@/util/DateUtils'
import HttpUtil from '@/util/HttpUtil'
import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

export default {
  data () {
    return {
      currentIdEmp: null, // guarda id_emp del registro actual
      wfMaster: {
        endpoint: 'wf_request',
        tableSetup: {
          tableConfig: {
            rowKey: 'wf_request_id'
          },
          columns: [
            {
              title: 'Estado',
              dataIndex: 'status',
              sorter: true,
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'estadoRenderer'
              }
            },
            {title: '# Solicitud', dataIndex: 'numero_solicitud', sorter: true},
            {title: 'Cod. Empleado', dataIndex: 'id_emp', sorter: true},
            {title: 'Identificación', dataIndex: 'id_person', sorter: true},
            {title: 'Nombre', dataIndex: 'nombre_empleado', sorter: true},
            {title: 'Días', dataIndex: 'dias', sorter: true},
            {title: 'Dinero', dataIndex: 'dinero', sorter: true},
            {
              title: 'F. Inicio',
              dataIndex: 'fecha_inicio_vacacion',
              sorter: true,
              scopedSlots: {filterDropdown: 'dateBetweenFilter'}
            },
            {
              title: 'F. Fin',
              dataIndex: 'fecha_fin_vacacion',
              sorter: true,
              scopedSlots: {filterDropdown: 'dateBetweenFilter'}
            },
            {title: 'Nombre Jefe', dataIndex: 'nombre_jefe', sorter: true},
            {title: 'Anticipada', dataIndex: 'vac_anticipada', sorter: true},
            {title: 'Observación', dataIndex: 'observacion', sorter: true},
            {title: 'F. Lim. Aprobación', dataIndex: 'fecha_limite_aprobacion', sorter: true},
            {title: 'F. Pago', dataIndex: 'fecha_pago', sorter: true},
            {title: 'F. Vencimiento Extra', dataIndex: 'fecha_vcto_vac_extra', sorter: true},
            {title: 'Días Extra', dataIndex: 'dias_extra', sorter: true},
            {title: 'Días Legales', dataIndex: 'dias_legal', sorter: true},
            {title: 'Causa Rechazo', dataIndex: 'causal_rechazo', sorter: true},
            {title: 'Resolución', dataIndex: 'id_resolution', sorter: true},
            {title: 'F. Resolución', dataIndex: 'resolution_date_desc', sorter: true},
            {title: 'Periodo de Pago', dataIndex: 'payment_period_desc', sorter: true}
          ],
          actions: {
            title: 'Acciones',
            scopedSlots: {customRender: 'hooverableAction'},
            width: 90,
            fixed: 'right',
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'},
                fnVisible: (record) => {
                  return record.status === 'APROBADA' && this.$userIsInrol('NoveltyHV')
                }
              }, {
                name: 'aprobarSolicitud',
                text: 'Aprobar para nomina',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'check'},
                fnVisible: (record) => {
                  return record.status === 'APROBADA' && this.$userIsInrol('rhappvac')
                }
              },
              {
                name: 'rechazar',
                text: 'Rechazar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'close', style: 'color:red'},
                fnVisible: (record) => {
                  return record.status === 'APROBADA' && this.$userIsInrol('rhappvac')
                }
              }
            ]
          },
          customSlots: ['estadoRenderer']
        },
        modalFieldsSetup: [
          {name: 'id_resolution'},
          {name: 'dias'},
          {name: 'resolution_date', type: 'date'},
          {name: 'payment_period'},
          {name: 'attribute9', type: 'date'},
          {name: 'start_date', type: 'date'},
          {name: 'requested_ammount'}
        ],
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        fecha_regreso: {
          loading: false,
          value: ''
        },
        colOptions: {xs: 24, sm: 8}
      },
      reqMaster: {
        endpoint: 'permission_req',
        tableSetup: {
          tableConfig: {
            rowKey: 'id'
          },
          columns: [
            {
              title: 'Estado',
              dataIndex: 'estado',
              sorter: true,
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'estadoRenderer'
              }
            },
            {title: '#', dataIndex: 'id', sorter: true},
            {title: 'Tipo Solicitud', dataIndex: 'desc_tipo_req', sorter: true},
            {title: 'Tipo Permiso', dataIndex: 'desc_tipo_permiso', sorter: true},
            {title: 'Subtipo', dataIndex: 'desc_subtipo', sorter: true},
            {title: 'Días', dataIndex: 'dias', sorter: true},
            {title: 'F. Permiso', dataIndex: 'date_permission_desc', sorter: true},
            {title: 'H. Inicio', dataIndex: 'time_leave', sorter: true},
            {title: 'H. Fin', dataIndex: 'time_return', sorter: true},
            {title: 'Cod. Empleado', dataIndex: 'id_emp', sorter: true},
            {title: 'Nombre', dataIndex: 'nombre', sorter: true},
            {title: 'Aprobador', dataIndex: 'id_approver_permission', sorter: true},
            {title: 'Nombre Aprobador', dataIndex: 'nombre_aprobador', sorter: true},
            {title: 'Observación', dataIndex: 'observation', sorter: true},
            {title: 'Atributo 1', dataIndex: 'att_1', sorter: true},
            {title: 'Atributo 2', dataIndex: 'att_2', sorter: true},
            {title: 'Atributo 3', dataIndex: 'att_3', sorter: true},
            {title: 'Atributo 4', dataIndex: 'att_4_desc', sorter: true},
            {title: 'Atributo 5', dataIndex: 'att_5_desc', sorter: true},
            {title: 'Atributo 6', dataIndex: 'att_6_desc', sorter: true},
            {title: 'Resolución', dataIndex: 'id_resolution', sorter: true},
            {title: 'F. Resolución', dataIndex: 'resolution_date_desc', sorter: true}
          ],
          actions: {
            title: 'Acciones',
            scopedSlots: {customRender: 'hooverableAction'},
            width: 120,
            fixed: 'right',
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'},
                fnVisible: (record) => {
                  return record.estado === 'PENDIENTE' || record.estado === 'APROBADA'// && this.$userIsInrol('rhappvac')
                }
              },
              {
                name: 'aprobarSolicitud',
                text: 'Aprobar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'check'},
                fnVisible: (record) => {
                  console.log(record)
                  return record.estado === 'APROBADA' || (record.estado === 'VALIDADA' && record.desc_tipo_req === 'CUENTA DE COBRO') || (record.estado === 'PENDIENTE' && this.$userIsInrol('rhappvac'))
                }
              },
              {
                name: 'rechazar',
                text: 'Rechazar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'close', style: 'color:red'},
                fnVisible: (record) => {
                  return record.estado === 'APROBADA' // && this.$userIsInrol('rhappvac')
                }
              },
              {
                name: 'descargar',
                text: 'Descargar',
                icon: 'download',
                props: {size: 'small', type: 'link', icon: 'download', style: 'color:blue;'},
                fnVisible: () => {
                  return true
                },
                fnLoading: (record) => {
                  return this.loadingBtns[record.id] === record.id
                }
              }
            ]
          },
          customSlots: ['estadoRenderer']
        },
        modalFieldsSetup: [
          {name: 'id_resolution'},
          {name: 'resolution_date', type: 'date'},
          {name: 'att_1'},
          {name: 'att_2'},
          {name: 'att_3'},
          {name: 'att_4'},
          {name: 'att_5'},
          {name: 'att_6'},
          {name: 'date_permission'},
          {name: 'days'},
          {name: 'id_approver_permission'},
          {name: 'id_emp'},
          {name: 'observation'},
          {name: 'state'},
          {name: 'sub_type_request'},
          {name: 'time_leave'},
          {name: 'time_return'},
          {name: 'type_permission'},
          {name: 'type_req'}
        ],
        solicitud: {h_lookup_type: 'TIPO_SOLICITUD'},
        permiso: {h_lookup_type: 'TIPO_PERMISO'},
        sub_tipo: {h_lookup_type: 'SUBTIPO_SOLICITUD_PERMISO'}
      },
      wfConfirmModal: {
        visible: false,
        loading: false,
        mensajeError: '',
        error: false,
        aprobar: null,
        aprobar_rechazar: '',
        comentario: ''
      },
      wfConfirmModalOtraSolicitud: {
        visible: false,
        loading: false,
        mensajeError: '',
        error: false,
        aprobar: null,
        aprobar_rechazar: '',
        comentario: '',
        visibleObs: true
      },
      wfCancelModalOtraSolicitud: {
        visible: false,
        loading: false,
        mensajeError: '',
        error: false,
        aprobar: null,
        aprobar_rechazar: '',
        comentario: ''
      },
      tipo_permiso_seleccionado: {equivalency: -1},
      activarResolucion: false,
      defaultKey: '1',
      loadingBtns: {},
      endpointExcel: 'permission_req_/downloadExcel',
      fileNameExcel: 'CONSULTA_OTRAS_SOLICITUDES',
      paramsT: {}
    }
  },
  mounted () {
    this.httpClient = new HttpUtil()
    this.activarResolucion = this.$getConfigValue('ACTIVAR_RESOLUCION_OTRAS_SOLICITUDES', 'NO') === 'SI'
    if (!this.activarResolucion) {
      this.wfMaster.tableSetup.columns.splice(this.wfMaster.tableSetup.columns.length - 3, 2)
      this.reqMaster.tableSetup.columns.splice(this.reqMaster.tableSetup.columns.length - 2, 2)
    }
  },
  methods: {
    fieldsChange (values) {
      if (!JsUtils.isEmpty(values.requested_ammount) && !JsUtils.isEmpty(values.requested_ammount.value)) {
        this.wfMaster.fecha_regreso.requested_ammount = values.requested_ammount.value
      }
      if (!JsUtils.isEmpty(values.start_date) && !JsUtils.isEmpty(values.start_date.value)) {
        this.$nextTick(() => {
          this.wfMaster.fecha_regreso.loading = true
          this.wfMaster.fecha_regreso.value = ''

          this.httpClient.getInstance().get('ss/solicitar_vacaciones/calcular_fecha_regreso_id_emp', {
            params: {
              fecha_inicio: DateUtils.forBackEnd(values.start_date.value),
              dias: this.wfMaster.fecha_regreso.requested_ammount,
              id_emp: this.currentIdEmp
            }
          })
            .then((response) => {
              let ff = moment(response.data)
              this.wfMaster.fecha_regreso.value = ff.format('YYYY-MM-DD')
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posible calcular la fecha de regreso.')
            })
            .then(() => {
              this.wfMaster.fecha_regreso.loading = false
            })
        })
      }
    },
    refreshTable () {
      this.$refs.wfMasterComponent.$refs.datatable.loadData()
    },
    masterAction (action) {
      this.wfMaster.fecha_regreso.loading = false
      this.wfMaster.fecha_regreso.value = ''

      // Guardar id_emp y dias del registro actual
      if (action.record) {
        if (action.record.id_emp) {
          this.currentIdEmp = action.record.id_emp
        }
        /*if (action.record.dias) {
          this.wfMaster.fecha_regreso.dias = action.record.dias
        } */
      }

      switch (action.action) {
        case 'aprobarSolicitud':
          this.wfConfirmModal.wf_request_id = action.record.wf_request_id
          this.wfConfirmModal.visible = true
          this.wfConfirmModal.error = false
          this.wfConfirmModal.loading = false
          this.wfConfirmModal.aprobar = true
          this.wfConfirmModal.aprobar_rechazar = 'aprobar'
          this.wfConfirmModal.comentario = ''
          break
        case 'rechazar':
          this.wfConfirmModal.wf_request_id = action.record.wf_request_id
          this.wfConfirmModal.visible = true
          this.wfConfirmModal.error = false
          this.wfConfirmModal.loading = false
          this.wfConfirmModal.aprobar = false
          this.wfConfirmModal.aprobar_rechazar = 'rechazar'
          this.wfConfirmModal.comentario = ''
          break
      }
    },
    masterActionOtraSolicitud (action) {
      switch (action.action) {
        case 'aprobarSolicitud':
          this.wfConfirmModalOtraSolicitud.visible = true
          this.wfConfirmModalOtraSolicitud.id = action.record.id
          this.wfConfirmModalOtraSolicitud.visibleObs = !(action.record.desc_tipo_req === 'CUENTA DE COBRO' && action.record.state === 'VALIDADA')
          break
        case 'rechazar':
          this.wfCancelModalOtraSolicitud.visible = true
          this.wfCancelModalOtraSolicitud.id = action.record.id
          break
        case 'masterEdit':
          this.tipo_permiso_seleccionado.equivalency = action.record.unidad_tiempo
          setTimeout(() => {
            this.$refs.masterOtrasSolicitudes.modal.form.setFieldsValue({
              time_leave: action.record.time_leave ? moment(action.record.time_leave, 'HH:mm') : null,
              time_return: action.record.time_return ? moment(action.record.time_return, 'HH:mm') : null
            })
          }, 500)
          break
        case 'descargar':
          this.descargarAdjunto(action.record)
          break
      }
    },
    cancelAprobar () {
      if (this.wfConfirmModal.loading) return

      this.wfConfirmModal.visible = false
      this.wfConfirmModal.error = false
      this.wfConfirmModal.accion = ''
    },
    confirmAprobar () {
      if (this.wfConfirmModal.loading) return
      this.wfConfirmModal.loading = true
      this.httpClient.getInstance().post('wf_request/aprobar', {
        wf_request_id: this.wfConfirmModal.wf_request_id,
        aprobar: this.wfConfirmModal.aprobar,
        comentario: this.wfConfirmModal.comentario
      }).then((response) => {
        if (JsUtils.isEmpty(response.data)) {
          this.refreshTable()
          this.wfConfirmModal.error = true
          this.wfConfirmModal.mensajeError = 'Error desconocido, por favor contactar al administrador.'
        } else {
          if (parseInt(response.data.resultado) === 2) {
            this.refreshTable()
            this.wfConfirmModal.error = false
            this.wfConfirmModal.loading = false
            this.wfConfirmModal.visible = false
            Mensajes.success('Correcto', response.data.mensaje)
          } else {
            this.refreshTable()
            this.wfConfirmModal.error = true
            this.wfConfirmModal.loading = false
            this.wfConfirmModal.mensajeError = response.data.mensaje
          }
        }
      }).catch((error) => {
        this.wfConfirmModal.error = true
        this.wfConfirmModal.mensajeError = error && error.response && error.response.data && error.response.data.message
        this.wfConfirmModal.loading = false
      })
    },
    confirmAprobarOtraSolicitud () {
      this.wfConfirmModalOtraSolicitud.loading = true
      this.httpClient.getInstance().post('wf_request/aprobar_otra_solicitud', {
        id: this.wfConfirmModalOtraSolicitud.id,
        comentario: this.wfConfirmModalOtraSolicitud.comentario,
        cuenta_cobro: !this.wfConfirmModalOtraSolicitud.visibleObs
      }).then((response) => {
        if (JsUtils.isEmpty(response.data)) {
          this.wfConfirmModalOtraSolicitud.error = true
          this.wfConfirmModalOtraSolicitud.mensajeError = 'Error desconocido, por favor contactar al administrador.'
        } else {
          this.$refs.masterOtrasSolicitudes.$refs.datatable.loadData()
          if (parseInt(response.data.pn_message_type) === 2 || response.data === 'OK') {
            this.wfConfirmModalOtraSolicitud.loading = false
            this.wfConfirmModalOtraSolicitud.visible = false
            this.wfConfirmModalOtraSolicitud.comentario = ''
            Mensajes.success('Correcto', response.data.mensaje)
          } else {
            this.wfConfirmModalOtraSolicitud.error = true
            this.wfConfirmModalOtraSolicitud.loading = false
            this.wfConfirmModalOtraSolicitud.mensajeError = response.data.pv_message
          }
        }
        // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        this.wfConfirmModalOtraSolicitud.loading = false
        Mensajes.error('Error', 'No se pudo aprobar esta solicitud')
      })
    },
    cancelAprobarOtraSolicitud () {
      this.wfConfirmModalOtraSolicitud.visible = false
      this.wfConfirmModalOtraSolicitud.comentario = ''
    },
    confirmRechazarSolicitud () {
      this.wfCancelModalOtraSolicitud.loading = true
      this.httpClient.getInstance().post('wf_request/rechazar_otra_solicitud', {
        id: this.wfCancelModalOtraSolicitud.id,
        comentario: this.wfCancelModalOtraSolicitud.comentario
      }).then((response) => {
        this.wfCancelModalOtraSolicitud.loading = false
        if (JsUtils.isEmpty(response.data)) {
          this.wfCancelModalOtraSolicitud.error = true
          this.wfCancelModalOtraSolicitud.mensajeError = 'Error desconocido, por favor contactar al administrador.'
        } else {
          if (parseInt(response.data.pn_message_type) === 2) {
            this.wfCancelModalOtraSolicitud.visible = false
            this.wfCancelModalOtraSolicitud.comentario = ''
            this.$refs.masterOtrasSolicitudes.$refs.datatable.loadData()

            Mensajes.success('Correcto', response.data.pv_message || 'Se rechazó esta solicitud con éxito')
          } else {
            this.wfCancelModalOtraSolicitud.error = true
            this.wfCancelModalOtraSolicitud.mensajeError = response.data.pv_message
          }
        }
        // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        this.wfCancelModalOtraSolicitud.loading = false
        Mensajes.error('Error', 'No se pudo rechazar esta solicitud')
      })
    },
    cancelRechazarSolicitud () {
      this.wfCancelModalOtraSolicitud.visible = false
    },
    descargarAdjunto (record, endpoint = 'ss/solicitar_permisos/download/') {
      /* La instancia no detecta el cambio en el componente tal vez por ser un slot, se actualiza la referencia */
      this.$nextTick(() => {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)
      })

      this.httpClient.getInstance().post(endpoint + record.id, {}, {responseType: 'arraybuffer'})
        .then(response => {
          let fileURL = new Blob([response.data], {type: response.headers['content-type']})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        })
        .catch(() => {
          this.$notification.error({
            message: 'Error descargando',
            description: 'No fue posible descargar el archivo, contacte al administrador.',
            duration: 1
          })
        })
        .then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
    },
    paramsTable (params) {
      this.paramsT = params
    }
  },
  computed: {
    canChangeFechaInicio () {
      return this.$userIsInrol('NoveltyHV')
    },
    activarDias () {
      return JsUtils.isEmpty(this.tipo_permiso_seleccionado) ? false : (this.tipo_permiso_seleccionado.equivalency === 'DIA')
    },
    activarHoras () {
      return JsUtils.isEmpty(this.tipo_permiso_seleccionado) ? false : (this.tipo_permiso_seleccionado.equivalency === 'HORA')
    },
    activarSubTipos () {
      return !JsUtils.isEmpty(this.tipo_permiso_seleccionado) && this.cantidadSubTipos > 0
    },
    canViewVacationReq () {
      let canView = this.$userIsInrol('adminCxC') || this.$userIsInrol('consultaCxC')
      this.defaultKey = canView ? '2' : '1'
      return !canView
    },
    paramsExcel () {
      return {...this.paramsT, columns: this.reqMaster.tableSetup.columns}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/WfRequest/WfRequest.vue